import AuthStore from 'auth/AuthStore'
import { snackbarError, snackbarSuccess } from 'reusable/mui/snackbar/snackbar'
import Loader from 'reusable/mobx-helpers/Loader'
import { FormHandlerConfig, formHandler } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import { ValidEmailSchema } from '@gap/backend/util/validations/validation-email'
import { makeAutoObservable } from 'mobx'
import { apiPublicClient } from 'api/trpc-public/trpc-client'

export default class AuthForgotPasswordStore {
   sp
   loader = new Loader()
   hasBeenSent = false
   fields = {
      email: '',
   }

   constructor(sp: { authStore: AuthStore }) {
      this.sp = sp
      makeAutoObservable(this)
   }

   get formHandler() {
      return formHandler(this.fields, {
         email: { type: 'string' },
      } satisfies FormHandlerConfig)
   }

   sendForgotPassword = async () => {
      if (!this.loader.isLoading) {
         this.loader.executeLoading(async () => {
            if (this.formHandler.validate(ValidEmailSchema)) {
               try {
                  await apiPublicClient.user.requestPasswordReset.mutate({ email: this.fields.email })

                  snackbarSuccess('A password reset code has been sent to your email. Please check your inbox.')

                  this.hasBeenSent = true
               } catch (error: unknown) {
                  const isError = error instanceof Error
                  if (!isError) {
                     snackbarError(`${error}`)
                     return
                  }
                  snackbarError(error.message ?? error)
               }
            }
         })
      }
   }
}
